import { render, staticRenderFns } from "./StartFormWizard.vue?vue&type=template&id=1ed96484&scoped=true&"
import script from "./StartFormWizard.vue?vue&type=script&lang=js&"
export * from "./StartFormWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed96484",
  null
  
)

export default component.exports